export const XP = '+200XP';
